var _path, _path2, _circle, _polygon, _path3, _polygon2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDogWalking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 741.84606,
    height: 522.41797,
    viewBox: "0 0 741.84606 522.41797",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520.793,516.6474a10.74264,10.74264,0,0,0-10.95628-12.30071l-68.80437-69.56692-13.59213,19.00109,71.90643,62.40721a10.80091,10.80091,0,0,0,21.44635.45933Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M488.20078,476.47743l-17.5613,17.542a4.51352,4.51352,0,0,1-6.335.02552L416.317,446.86677a17.603,17.603,0,1,1,24.93713-24.849l46.98661,48.13244A4.51547,4.51547,0,0,1,488.20078,476.47743Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#1975d2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 197.53395,
    cy: 177.02015,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "114.543 471.345 120.762 481.91 164.474 462.951 155.295 447.357 114.543 471.345",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345.48345,655.41085l12.24733,20.80687.00049.00085a15.386,15.386,0,0,1-5.45551,21.06459l-.4309.25361-20.05237-34.067Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.6 509.407 198.86 509.407 204.692 462.119 186.598 462.12 186.6 509.407",
    fill: "#ffb8b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M412.55,694.1958l24.1438-.001h.001a15.38605,15.38605,0,0,1,15.38647,15.38623v.5l-39.53052.00146Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M366.38843,669.54838a4.49319,4.49319,0,0,1-3.624-1.833l-11.82373-16.0586a4.4996,4.4996,0,0,1,1.12452-6.41015l52.614-35.1416-31.74658-83.47461,67.88916,5.60254,2.28662,71.7334a36.04577,36.04577,0,0,1-18.04517,32.42382l-56.42651,32.55371A4.48594,4.48594,0,0,1,366.38843,669.54838Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M416.04712,688.59818a4.49988,4.49988,0,0,1-4.48877-4.33984l-2.488-69.88184,30.80835-1.623-2.45312,70.38379a4.48729,4.48729,0,0,1-4.19971,4.333l-16.8728,1.11817C416.25073,688.59525,416.14868,688.59818,416.04712,688.59818Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M448.67871,546.1099c-7.83838,0-35.21655-8.81641-44.72119-11.959-1.42188,1.13769-9.23315,6.97851-18.35107,5.91113-5.626-.66016-10.57886-3.84473-14.721-9.46582-9.147-12.41406,2.15063-65.65137,13.239-108.126a34.26782,34.26782,0,0,1,40.52857-24.87988h0a34.57136,34.57136,0,0,1,26.08764,25.37793c2.08765,8.498.29175,18.49414-1.01953,25.79394-.61645,3.43164-1.10351,6.14258-.937,7.47461.64355,5.14844,4.21875,85.8916,1.91992,89.33985C450.45923,545.94388,449.75122,546.1099,448.67871,546.1099Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#1975d2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M420.00379,546.25292a10.74266,10.74266,0,0,0,.9416-16.44569l.48533-97.84356-23.04478,3.8374,6.76925,94.97037a10.80091,10.80091,0,0,0,14.8486,15.48148Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M425.33374,494.79935H400.512a4.51352,4.51352,0,0,1-4.5-4.459l-.60937-67.292a17.603,17.603,0,1,1,35.2041.043l-.77319,67.25976A4.51547,4.51547,0,0,1,425.33374,494.79935Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#1975d2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M420.35705,390.26988c-11.24529.02059-21.85416-8.868-23.80286-19.94323a28.67148,28.67148,0,0,1,.91927-13.01372,34.95394,34.95394,0,0,1,47.93529-21.95277c3.00832,1.36131,5.97146,3.31644,7.3489,6.31741s.51536,7.19528-2.49791,8.5456c-1.96915.88243-4.44022.4491-6.18718,1.71574-2.50929,1.81936-1.86334,5.69129-.74286,8.58112s2.38775,6.38691.50946,8.85239c-1.75023,2.29738-5.24872,2.22609-8.00435,1.36136s-5.47558-2.31276-8.34865-2.01821c-4.19039.4296-7.20172,4.59773-7.7591,8.77305s.75474,8.34892,2.05018,12.35714Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M727.69556,415.33663c0-67.16541,54.44832-226.54561,121.61373-226.54561S970.923,348.17122,970.923,415.33663a121.61373,121.61373,0,1,1-243.22747,0Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#1975d2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M849.30925,711.209a1,1,0,0,1-1-1V290.9248a1,1,0,0,1,2,0V710.209A1,1,0,0,1,849.30925,711.209Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M849.30925,371.87061a.99683.99683,0,0,1-.70715-.293l-48.13452-48.13428a1,1,0,0,1,1.41431-1.41406l48.13452,48.13427a1,1,0,0,1-.70716,1.707Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M849.30925,455.20068a1,1,0,0,1-.70715-1.707l80.61-80.61035a1,1,0,0,1,1.4143,1.41406l-80.61,80.61035A.997.997,0,0,1,849.30925,455.20068Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M512.75454,516.07833c15.95481-3.60678,34.03035,8.87341,34.59062,25.62768.15759,4.71249-1.22354,9.66138-4.84973,12.86729-2.99372,2.64675-7.44863,3.9815-11.3187,2.68784-7.44737-2.48945-7.845-12.86687-3.85-18.40942,5.40939-7.50479,16.12575-8.78623,24.62919-7.89363,10.3961,1.09127,20.27689,5.64956,28.56833,11.89757,16.5987,12.50793,27.168,31.67789,35.72289,50.19942a253.09711,253.09711,0,0,1,18.95912,59.57906q.72364,3.8748,1.32589,7.77061a1.51056,1.51056,0,0,0,1.8598,1.02108,1.53833,1.53833,0,0,0,1.02107-1.8598,256.43885,256.43885,0,0,0-19.2345-65.06188c-8.95744-20.07249-20.2501-40.89324-38.21465-54.28884-8.95541-6.67776-19.53073-11.32453-30.72247-12.31825-9.42172-.83656-20.57851,1.15666-26.43759,9.351-4.62229,6.46462-4.15275,17.20837,2.9993,21.71061,3.932,2.47519,8.9283,2.186,13.011.26156a16.66327,16.66327,0,0,0,8.786-10.89127c2.5395-9.30518-1.31669-19.36986-7.92811-26.021a33.31988,33.31988,0,0,0-23.45167-9.86212,29.53,29.53,0,0,0-6.30452.75164c-1.88353.42579-1.04178,3.306.83872,2.88088Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M589.698,700.34085l-9.91475-16.92813,12.22567-7.16079,9.91474,16.92759v.00053a7.0842,7.0842,0,0,1-12.22566,7.1608Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#1975d2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.83846,
    cy: 467.64477,
    r: 8.71897,
    fill: "#1975d2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M628.05951,700.34085l-9.91474-16.92813,12.22539-7.16079,9.91475,16.92759a7.08423,7.08423,0,0,1-12.2254,7.16133Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#1975d2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M558.572,674.00087a18.5487,18.5487,0,0,1,18.52781-18.52781h58.65109a7.84026,7.84026,0,0,1,7.83106,7.83132v6.67387a22.57592,22.57592,0,0,1-22.55044,22.55044H577.09978A18.5487,18.5487,0,0,1,558.572,674.00087Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M572.09744,702.52378V682.9061h14.16833v19.61768a7.08416,7.08416,0,1,1-14.16833,0Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M613.21,702.52378V682.9061h14.16833v19.61768a7.08417,7.08417,0,1,1-14.16833,0Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M670.85511,624.90772A8.719,8.719,0,0,1,684.451,635.82717l-14.33179,17.84456-13.59585-10.91946Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#1975d2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M636.332,660.06044l11.48163-14.29581a16.81159,16.81159,0,0,1,23.6078-2.57733l3.58734,2.88115a20.04437,20.04437,0,0,1,3.07294,28.14757l-9.45955,11.77812a6.29434,6.29434,0,0,1-8.83883.96477l-22.48639-18.05985A6.29412,6.29412,0,0,1,636.332,660.06044Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M672.56128,622.78336a5.99429,5.99429,0,1,1,9.34715,7.50713L665.87048,650.2594l-9.34715-7.50713Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M649.58579,656.16211l24.64248,19.79151a8.719,8.719,0,0,1-10.91945,13.59586L638.66633,669.758Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.02816,
    cy: 687.57741,
    rx: 3.67832,
    ry: 2.04351,
    transform: "translate(-512.82845 594.53242) rotate(-51.23045)",
    fill: "#1975d2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M921.077,711.02362h-691a1,1,0,1,1,0-2h691a1,1,0,0,1,0,2Z",
    transform: "translate(-229.07697 -188.79102)",
    fill: "#ccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogWalking);
export default __webpack_public_path__ + "static/media/dog_walking.570824e1.svg";
export { ForwardRef as ReactComponent };